import React from "react"
import "./overView.css"
import Heading from "../Heading"

export class OverView extends React.Component {
	constructor (args) {
		super(args)
		this.state = {}
	}
	render () {
		return (
			<div className="section__content" style={{ display: "none" }}>
				<div className="overview__wrapper">
					<div className="overview__section">
						<div className="overview_content">
							<div className="low__heading">Overview</div>
							<div className="">
								<Heading title="About Winpe" />
							</div>
							{/* <div className="sub__text__muted">
															Lorem ipsum dolor sit amet
														</div> */}
							<div className="sub_text">
							Winpe is a not for profit, pioneering platform for the private equity (PE) industry, to bring about
								transformation of mindsets in favour of gender diversity, while helping to create more opportunities for
								women in PE.
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default OverView



// WEBPACK FOOTER //
// ./src/components/overView/index.js